import { defineStore } from 'pinia'

export const DEFAULTS = [
  'shop_service_hotline',
  'shop_service_email',
  'customer_testimonials',
  'wm_testimonials',
  'new_lg_selector'
]

export const useCmsVariables = defineStore('cmsVariables', {
  state: () => ({ variables: {} }),
  getters: {
    getContent:
      ({ variables }) =>
      (key) =>
        variables[key]
  },
  actions: {
    update(data) {
      this.variables = {
        ...this.variables,
        ...data.reduce(
          (col, { identifier, value }) => ({
            ...col,
            [identifier]: value
          }),
          {}
        )
      }
    },
    async fetchOne(id) {
      if (this.variables[id]) return

      await _fetchVariable(_batchFor(this), id, this.update)
    },
    async fetchDefaults() {
      const batch = _batchFor(this)
      DEFAULTS.forEach((id) => {
        _fetchVariable(batch, id, this.update).catch(() => {})
      })
    }
  }
})

const DEBOUNCE_TIME = 1000 // ms

// The pending-variable queue and its debounce timer are per store instance:
// at module scope concurrent server renders would share one queue, so one
// request could consume or clear another's batch (VIP-12037).
const _batches = new WeakMap()
const _batchFor = (store) => {
  if (!_batches.has(store)) _batches.set(store, { pending: [], timeout: null })
  return _batches.get(store)
}

const _fetchVariable = async (batch, id, cb) => {
  if (batch.pending.includes(id)) return

  clearTimeout(batch.timeout)
  batch.pending = [...batch.pending, id]
  batch.timeout = setTimeout(_getHandler(batch, cb), DEBOUNCE_TIME)
}

const _getHandler = (batch, cb) => {
  return async () => {
    const { ApiController } = await _getModules()
    const requested = batch.pending
    try {
      const data = await ApiController.fetchCmsVariable(requested)
      cb(data)
      batch.pending = []
    } catch (e) {
      console.error('Error fetching CMS variables: ' + requested.join(', '), e)
    }
  }
}

const _getModules = (() => {
  let cache

  return async () => {
    if (cache) return cache

    const { API_URL } = await import('@/constants/GlobalConstants')
    const { default: RequestHelper } =
      await import('@/services/helpers/RequestHelper')
    const { default: UtilityHelper } =
      await import('@/services/helpers/UtilityHelper')
    const { default: ApiController } = await import('@/services/ApiController')

    cache = { RequestHelper, UtilityHelper, API_URL, ApiController }
    return cache
  }
})()
